import React from 'react';
import MetricsAnalytics from '../components/metrics/metrics';
import { hasPermission } from '../components/auth/login/Login';
import { useNavigate } from 'react-router-dom';

function Metrics() {
	const canReadMetrics = hasPermission("Metrics", "Metric", "read");
	const navigate = useNavigate();

	if (!canReadMetrics) {
		navigate('/no-permission')
	}

	return (
		<MetricsAnalytics />
	)
}

export default Metrics